import axios from "axios";

// Определяем базовый URL для API
const getBaseURL = () => {
  // В продакшене используем текущий домен
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }
  // В разработке используем localhost
  return process.env.REACT_APP_API_URL || "http://localhost:5000";
};

// Получение и сохранение CSRF-токена
async function fetchAndStoreCsrfToken() {
  try {
    console.log('🔄 [CSRF] Запрашиваем CSRF токен...');
    const { data } = await axios.get(`${getBaseURL()}/api/csrf-token`, { withCredentials: true });
    console.log('📥 [CSRF] Получен ответ:', data);
    if (data.csrfToken) {
      console.log('💾 [CSRF] Токен получен от сервера');
    } else {
      console.warn('⚠️ [CSRF] CSRF токен не найден в ответе');
    }
  } catch (error) {
    console.error('❌ [CSRF] Ошибка при получении CSRF токена:', error);
  }
}

const $host = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
});

const $authHost = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
});

// Добавляем токен авторизации
$authHost.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function generateClientCsrfToken() {
  try {
    if (window.crypto && window.crypto.getRandomValues) {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');
    }
  } catch (_) {}
  return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
}

function setCookieCsrf(token) {
  try {
    document.cookie = `csrfToken=${token}; path=/; SameSite=Lax`;
  } catch (_) {}
}

// Добавляем CSRF-токен для всех изменяющих запросов
async function addCsrfToken(config) {
  const method = config.method?.toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    // Get CSRF token from server-set cookie
    let csrfToken = null;
    
    // Try to get token from cookies
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'csrfToken') {
        csrfToken = value;
        break;
      }
    }
    
    console.log('🔍 [CSRF] Проверяем CSRF токен для', method, 'запроса:', {
      hasToken: !!csrfToken,
      tokenLength: csrfToken?.length,
      url: config.url
    });
    
    // Если токен отсутствует или содержит null, пытаемся получить с сервера, иначе генерируем локально
    if (!csrfToken || csrfToken.includes('null')) {
      console.log('🔄 [CSRF] Токен отсутствует или содержит null, пытаемся получить...');
      try {
        await fetchAndStoreCsrfToken();
        // Повторно читаем из cookie
        const cookies2 = document.cookie.split(';');
        for (const cookie of cookies2) {
          const [name, value] = cookie.trim().split('=');
          if (name === 'csrfToken') {
            csrfToken = value;
            break;
          }
        }
      } catch (error) {
        console.warn('⚠️ [CSRF] Серверный токен недоступен, сгенерируем локальный');
      }
      if (!csrfToken || csrfToken.includes('null')) {
        csrfToken = generateClientCsrfToken();
        setCookieCsrf(csrfToken);
        console.log('✅ [CSRF] Сгенерирован локальный токен');
      }
    }
    
    if (csrfToken && !csrfToken.includes('null')) {
      console.log('🔧 [CSRF] Используем токен:', csrfToken.substring(0, 20) + '...');
      
      // Отправляем токен в заголовке X-CSRF-Token
      config.headers = config.headers || {};
      config.headers['X-CSRF-Token'] = csrfToken;
      console.log('✅ [CSRF] Токен добавлен в заголовки');
    } else {
      console.warn('⚠️ [CSRF] CSRF токен не найден в cookies или содержит null');
    }
  }
  return config;
}

$host.interceptors.request.use(async (config) => {
  await addCsrfToken(config);
  return config;
});

$authHost.interceptors.request.use(async (config) => {
  await addCsrfToken(config);
  return config;
});

// Добавляем перехватчик ответов для логирования ошибок и обработки 429
function logError(error) {
  // Если это ошибка 429, не логируем её как ошибку
  if (error.response?.status === 429) {
    console.warn('Rate limit exceeded:', error.config?.url);
    return Promise.reject(error);
  }
  
  console.error('API Error:', {
    status: error.response?.status,
    data: error.response?.data,
    config: {
      url: error.config?.url,
      method: error.config?.method,
      data: error.config?.data
    }
  });
  return Promise.reject(error);
}

$host.interceptors.response.use(
  response => response,
  logError
);

$authHost.interceptors.response.use(
  response => response,
  logError
);

export { $host, $authHost, fetchAndStoreCsrfToken }; 